(function ($) {

    const initializeBlock = function ($block) {
      function matchHeightFire() {
        $('.featureBoxes .contentStyled .contentStyled-image').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .contentStyled h1').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .contentStyled h2').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .contentStyled h3').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .contentStyled h4').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .contentStyled h5').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .contentStyled h6').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .contentStyled p').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .contentStyled .btn').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .contentStyled .paragraphContent').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .contentStyled .listStyled').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .contentStyled').matchHeight( {property: 'min-height'} );
        $('.featureBoxes .featureBox .featureBox-bottom_image').matchHeight( {property: 'min-height'} );
      }
      matchHeightFire()

      $( window ).bind('resize orientationchange', function() {
          matchHeightFire();
      });

      setTimeout(function() {
          matchHeightFire();
      }, 1000)
    }

    $(document).ready(function () {
        $('.block--feature-boxes').each(function () {
            initializeBlock($(this));
        })
    })

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=feature-boxes', initializeBlock);
    }

})(jQuery);